"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.DelaySubscriptionEvent = void 0;
const Name = exports.Name = 'delay-subscription';
const DelaySubscriptionEvent = exports.DelaySubscriptionEvent = Name;
//# sourceMappingURL=index.js.map